"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _turf = require("@turf/turf");
var _lodash = require("lodash");
var _maplibre = _interopRequireWildcard(require("react-map-gl/maplibre"));
var _Preferences = _interopRequireDefault(require("chaire-lib-common/lib/config/Preferences"));
var _ServiceLocator = _interopRequireDefault(require("chaire-lib-common/lib/utils/ServiceLocator"));
var _InputSelect = _interopRequireDefault(require("chaire-lib-frontend/lib/components/input/InputSelect"));
var _LodashExtensions = require("chaire-lib-common/lib/utils/LodashExtensions");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
class ZonesInteractiveMap extends _react.default.Component {
  constructor(props) {
    super(props);
    this.mapRef = /*#__PURE__*/_react.default.createRef();
    this.state = {
      viewport: {
        longitude: _Preferences.default.get('map.center')[0],
        latitude: _Preferences.default.get('map.center')[1],
        zoom: _Preferences.default.get('map.zoom')
      },
      currSelection: {
        origin: props.selected ? (0, _toConsumableArray2.default)(props.selected.origin) : [],
        destination: props.selected ? (0, _toConsumableArray2.default)(props.selected.destination) : []
      },
      hoverId: "",
      eventFeatures: {},
      popupOptions: {},
      showPopup: false,
      zoneType: props.zoneType ? props.zoneType : 'origin',
      level: this.props.defaultLevel ? this.props.defaultLevel : 0,
      maxLevel: this.props.aggregations ? (0, _lodash.max)(this.props.aggregations.map(item => item.level)) : 0,
      sortedLevels: this.props.aggregations ? this.props.aggregations.map(item => item.level).sort() : [] //sorting in descending order
    };
    this.colors = this.props.colors ? this.props.colors : {
      origin: {
        main: "#468024",
        sub: "#000000"
      },
      destination: {
        main: "#468024",
        sub: "#000000"
      }
    };
    const aggregations = _ServiceLocator.default.collectionManager.get('aggregatedZones');
    this.state = _objectSpread(_objectSpread({}, this.state), {}, {
      aggregations
    });
    this.onViewportChange = this.onViewportChange.bind(this);
    this.onClick = this.onClick.bind(this);
    this.onHover = this.onHover.bind(this);
    this.onClickDeleteSelection = this.onClickDeleteSelection.bind(this);
    this.onClickSelectZone = this.onClickSelectZone.bind(this);
    this.onClickOrigin = this.onClickOrigin.bind(this);
    this.onClickDestination = this.onClickDestination.bind(this);
    this.onChange_lvl = this.onChange_lvl.bind(this);
    this.getLevelaggObjectName = this.getLevelaggObjectName.bind(this);
    this.featureAggregator = this.featureAggregator.bind(this);
    this.renderLayers = this.renderLayers.bind(this);
    this.renderControlPanel = this.renderControlPanel.bind(this);
  }
  componentDidMount() {
    _ServiceLocator.default.eventManager.emit(`${process.env.APP_NAME}Zones.selection`, this.state.currSelection);
  }
  componentWillUnmount() {
    const newViewport = {
      'map.center': [this.state.viewport.longitude, this.state.viewport.latitude],
      'map.zoom': this.state.viewport.zoom
    };
    _Preferences.default.update(_ServiceLocator.default.socketEventManager, _ServiceLocator.default.eventManager, newViewport);
  }
  onViewportChange(viewport) {
    this.setState({
      viewport
    });
  }
  onClick(event) {
    const {
      zoneType,
      showPopup,
      level,
      currSelection
    } = this.state;
    //first we get the list of all element selected regarding aggregation level
    let selectedElements;
    if (level === 0) {
      selectedElements = [event.features[0].properties.id];
    } else {
      const lvlObjecName = this.getLevelaggObjectName(level);
      const objectId = event.features[0].properties[lvlObjecName];
      const selectedFeatures = this.props.data.features.filter(feature => feature.properties[lvlObjecName] === objectId);
      selectedElements = selectedFeatures.map(feature => feature.properties.id);
    }

    //then we add or substract selected zone to currSelection
    //we reselect a zone if at least one of its elements is not selected
    const newSelection = _objectSpread({}, currSelection);
    newSelection[zoneType] = Array.isArray(newSelection[zoneType]) ? newSelection[zoneType] : [];
    if (selectedElements.every(id => newSelection[zoneType].includes(id))) {
      selectedElements.forEach(id => {
        if (newSelection[zoneType].includes(id)) {
          const idIdx = newSelection[zoneType].indexOf(id);
          newSelection[zoneType].splice(idIdx, 1);
        }
      });
    } else {
      selectedElements.forEach(id => {
        if (!newSelection[zoneType].includes(id)) {
          newSelection[zoneType].push(id);
        }
      });
    }
    newSelection[zoneType] = newSelection.length === 0 ? "" : newSelection[zoneType];
    this._updateSelection(newSelection);
  }
  onHover(event) {
    if (!this.state.showPopup) {
      if (event.features && event.features[0] && event.features[0].properties.data && event.features[0].properties.id != this.state.hoverId) {
        const hoverId = event.features[0].properties[this.getLevelaggObjectName(this.state.level)];
        this.setState({
          hoverId
        });
      }
    }
  }
  onClickDeleteSelection(e) {
    e.preventDefault();
    const newSelection = _objectSpread({}, this.state.currSelection);
    newSelection[this.state.zoneType] = [];
    this._updateSelection(newSelection);
  }
  onClickSelectZone(e, zoneProps, propName) {
    e.preventDefault();
    const newSelection = _objectSpread({}, this.state.currSelection);
    //then we add or substract selected zone to currSelection
    //we reselect a zone if at least one of its elements is not selected
    //raw prop name can be used to pass direct zone ids. In this case we won't filter them via componant data
    let zoneIds;
    if (propName === "raw") {
      zoneIds = zoneProps;
    } else zoneIds = this.props.data.features.filter(zone => zone.properties.data[propName] && zoneProps.includes(zone.properties.data[propName])).map(zone => zone.properties.id);
    if (zoneIds.every(id => newSelection[this.state.zoneType].includes(id))) {
      zoneIds.forEach(id => {
        if (newSelection[this.state.zoneType].includes(id)) {
          const idIdx = newSelection[this.state.zoneType].indexOf(id);
          newSelection[this.state.zoneType].splice(idIdx, 1);
        }
      });
    } else {
      zoneIds.forEach(id => {
        if (!newSelection[this.state.zoneType].includes(id)) {
          newSelection[this.state.zoneType].push(id);
        }
      });
    }
    this._updateSelection(newSelection);
  }
  onClickOrigin(e) {
    e.stopPropagation();
    e.preventDefault();
    const currSelection = this.state.currSelection;
    if (this.props.ableUniqueSelector) {
      currSelection.destination = [];
      _ServiceLocator.default.eventManager.emit(`${process.env.APP_NAME}Zones.selection`, currSelection);
    }
    this.setState({
      zoneType: "origin",
      showPopup: false,
      currSelection
    });
  }
  onClickDestination(e) {
    e.preventDefault();
    const currSelection = this.state.currSelection;
    if (this.props.ableUniqueSelector) {
      currSelection.origin = [];
      _ServiceLocator.default.eventManager.emit(`${process.env.APP_NAME}Zones.selection`, currSelection);
    }
    this.setState({
      zoneType: "destination",
      showPopup: false,
      currSelection
    });
  }
  onChange_lvl(e) {
    e.preventDefault();
    this.setState({
      level: parseInt(e.target.value),
      showPopup: false
    });
  }
  _updateSelection(newSelection) {
    this.setState({
      currSelection: newSelection,
      showPopup: false
    });
    _ServiceLocator.default.eventManager.emit(`${process.env.APP_NAME}Zones.selection`, newSelection);
  }
  getLevelaggObjectName(level) {
    if (level === 0) {
      return "id";
    } else {
      const levelProp = this.props.aggregations.filter(lvl => lvl.level === level)[0];
      return this.state.aggregations[`data_lvl${level}`].aggregator;
    }
  }
  getAggregationChoices() {
    const choices = [{
      value: 0,
      label: this.props.aggregationLocalPrefix ? `${this.props.t('osc2ar:by')} ${this.props.t(`${this.props.aggregationLocalPrefix}:lvl0`)}` : "level 0"
    }];
    for (let aggregation of this.props.aggregations) {
      choices.push({
        value: aggregation.level,
        label: this.props.aggregationLocalPrefix ? `${this.props.t('osc2ar:by')} ${this.props.t(`${this.props.aggregationLocalPrefix}:lvl${aggregation.level}`)}` : `level ${aggregation.level}`
      });
    }
    return choices;
  }
  featureAggregator(aggAtribute, featureSet) {
    const aggArray = (0, _lodash.groupBy)(featureSet.features, item => item.properties.data[aggAtribute]);
    const features = Object.keys(aggArray).map((key, idx) => {
      const item = aggArray[key];
      // we order SR by desc size to make union easier to calculate
      item.sort((a, b) => {
        return (0, _LodashExtensions._isBlank)(a.geometry) || (0, _LodashExtensions._isBlank)(b.geometry) ? 1 : b.geometry.coordinates[0].length - a.geometry.coordinates[0].length;
      });
      const geometry = item.reduce((accUnion, feature, index) => index ? (0, _turf.union)(accUnion, feature) : null);
      geometry['id'] = idx;
      geometry.properties['ids'] = item.map(x => x.properties.id);
      geometry.properties['name'] = key;
      return geometry;
    });
    return {
      features: features,
      type: "FeatureCollection"
    };
  }
  renderLayers() {
    const {
      zoneType,
      showPopup,
      hoverId,
      currSelection,
      eventFeatures
    } = this.state;
    const main = zoneType;
    const sub = zoneType == 'origin' ? 'destination' : 'origin';
    const layers = [];

    // construction of aggregated layers
    if (this.state.maxLevel > 0) {
      for (let lvlIdx in this.state.sortedLevels) {
        const lvl = this.state.sortedLevels[lvlIdx];
        layers.push(/*#__PURE__*/_react.default.createElement(_maplibre.Source, {
          id: `zonesLvl${lvl}`,
          key: `zonesLvl${lvl}`,
          type: "geojson",
          data: this.state.aggregations[`data_lvl${lvl}`]
        }, /*#__PURE__*/_react.default.createElement(_maplibre.Layer, {
          id: `borders_lvl${lvl}`,
          beforeId: lvlIdx == this.state.sortedLevels.length - 1 ? null : `borders_lvl${this.state.sortedLevels[parseInt(lvlIdx) + 1]}` // shoud be "road-label-small" for highest level  //warning "===" comparison doesn't work --> needs to be "==" for types reasons
          ,
          type: "line",
          paint: {
            "line-color": `rgb(${30 * (1 - lvl / this.state.maxLevel)},${30 * (1 - lvl / this.state.maxLevel)},${30 * (1 - lvl / this.state.maxLevel)})`
          }
        })));
      }
    }
    // then we add layers for level 0
    layers.push(/*#__PURE__*/_react.default.createElement(_maplibre.Source, {
      id: "zonesLvl0",
      key: "zonesLvl0",
      type: "geojson",
      data: this.props.data
    }, /*#__PURE__*/_react.default.createElement(_maplibre.Layer, {
      id: "borders_lvl0",
      beforeId: this.state.maxLevel > 0 ? `borders_lvl${this.state.maxLevel}` : "road-label-small",
      type: "line",
      paint: {
        'line-color': this.state.maxLevel > 0 ? `rgb(30,30,30)` : 'rgb(0,0,0)',
        'line-opacity': 0.75
      }
    }), /*#__PURE__*/_react.default.createElement(_maplibre.Layer, {
      id: "hoveredZone",
      beforeId: "borders_lvl0",
      type: "fill",
      filter: ['in', this.getLevelaggObjectName(this.state.level), showPopup ? eventFeatures[this.getLevelaggObjectName(this.state.level)] : hoverId],
      paint: {
        'fill-color': '#193d85',
        'fill-opacity': 0.5
      }
    }), /*#__PURE__*/_react.default.createElement(_maplibre.Layer, {
      id: "mainSelection",
      beforeId: "hoveredZone",
      type: "fill",
      filter: ['in', 'id'].concat(currSelection[main]),
      paint: {
        "fill-color": this.colors[main].main,
        'fill-opacity': 0.7
      }
    }), /*#__PURE__*/_react.default.createElement(_maplibre.Layer, {
      id: "subSelection",
      beforeId: "mainSelection",
      type: "fill",
      filter: ['in', 'id'].concat(currSelection[sub]),
      paint: {
        'fill-color': this.colors[sub].sub,
        'fill-opacity': 0.3
      }
    }), /*#__PURE__*/_react.default.createElement(_maplibre.Layer, {
      id: "zones",
      beforeId: "subSelection",
      type: "fill",
      paint: {
        'fill-color': 'rgba(255,255,255,0.2)'
      }
    })));
    return layers;
  }
  renderControlPanel() {
    const {
      zoneType,
      level
    } = this.state;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "mapButton_container",
      style: {
        zIndex: this.props.style.zIndex == 0 ? 0 : this.props.style.zIndex + 1
      }
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "buttonZonesSelection_container",
      style: {}
    }, /*#__PURE__*/_react.default.createElement("button", {
      className: "_input",
      onClick: this.onClickDeleteSelection
    }, " ", this.props.t('osc2ar:deleteSelection')), this.props.groupedZones && this.props.groupedZones.map(zone => {
      //we llok if all zone in group are selected to have relevant class name
      let zoneIds;
      if (zone.propName === "raw") {
        zoneIds = zone.ids;
      } else zoneIds = this.props.data.features.filter(zoneInfo => zoneInfo.properties.data[zone.propName] && zone.ids.includes(zoneInfo.properties.data[zone.propName])).map(zoneInfo => zoneInfo.properties.id);
      const selectionIncludesAllGroupZones = zoneIds.every(id => this.state.currSelection[this.state.zoneType].includes(id));
      return /*#__PURE__*/_react.default.createElement("button", {
        key: `zone_button_${zone.name}`,
        className: selectionIncludesAllGroupZones ? "_input _input-select-button _green" : "_input",
        onClick: e => this.onClickSelectZone(e, zone.ids, zone.propName)
      }, " ", `${this.props.t('osc2ar:selectZone')} : ${this.props.t(`${this.props.groupedZonesLocalPrefix}:${zone.name}`)}`);
    })), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
      className: "buttonOriginDestination_container",
      style: {}
    }, /*#__PURE__*/_react.default.createElement("button", {
      id: "origin",
      className: "buttonOriginDestination",
      style: {
        backgroundColor: `${zoneType == "origin" ? this.colors.origin.main : "#ffffff"}`
      },
      onClick: this.onClickOrigin,
      disabled: zoneType == "origin"
    }, " ", this.props.t('osc2ar:origin')), /*#__PURE__*/_react.default.createElement("button", {
      id: "destination",
      className: "buttonOriginDestination",
      style: {
        backgroundColor: `${zoneType == "destination" ? this.colors.destination.main : "#ffffff"}`
      },
      onClick: this.onClickDestination,
      disabled: zoneType == "destination"
    }, " ", this.props.t('osc2ar:destination'))), /*#__PURE__*/_react.default.createElement("div", {
      className: "buttonOriginDestination_container",
      style: {
        top: "5px"
      }
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "buttonAggregationLevel"
    }, /*#__PURE__*/_react.default.createElement(_InputSelect.default, {
      className: "buttonAggregationLevel",
      choices: this.getAggregationChoices(),
      value: level,
      onValueChange: e => this.onChange_lvl(e),
      noBlank: true
    })))));
  }
  render() {
    const {
      showPopup,
      viewport,
      eventFeatures
    } = this.state;
    const popupPosition = showPopup ? (0, _turf.centroid)(eventFeatures.geometry) : "";
    const isMapActive = (0, _LodashExtensions._isBlank)(this.props.isActive) ? true : this.props.isActive;
    return /*#__PURE__*/_react.default.createElement("div", null, isMapActive && /*#__PURE__*/_react.default.createElement("div", null, this.renderControlPanel(), /*#__PURE__*/_react.default.createElement(_maplibre.default, {
      initialViewState: viewport,
      style: this.props.style,
      ref: this.mapRef,
      width: "100%",
      height: this.props.style.height,
      onMove: event => this.onViewportChange(event.viewState),
      onClick: this.onClick,
      onHover: this.onHover,
      dragRotate: false,
      mapStyle: "https://demotiles.maplibre.org/style.json"
    }, this.renderLayers())));
  }
}
ZonesInteractiveMap.defaultProps = {
  allowComplexUi: true,
  lvl_0_label_key: "id"
};
ZonesInteractiveMap.propTypes = {
  style: _propTypes.default.object,
  data: _propTypes.default.object,
  section: _propTypes.default.string,
  allowComplexUi: _propTypes.default.bool,
  levels: _propTypes.default.object
};

// var a = document.createElement("a");
// var file = new Blob([JSON.stringify(this.state.currSelection)], {type: 'text/plain'});
// a.href = URL.createObjectURL(file);
// a.download = 'zoneIds.json';
// a.click();
var _default = exports.default = (0, _reactI18next.withTranslation)()(ZonesInteractiveMap);